import React from "react";
import "../styles/footer.css";
import { ReactComponent as LogoSVG } from "../assets/icons/eliteVacances.svg";

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-azul text-center text-lg-start p-1 fixed-bottom">
      <div className="container text-center text-md-start mt-5">
        <div className="row">
          <div className="col-sm-6 col-md-3 col-lg-3 col-xl-3 mx-auto mb-4">
            <a
              href="https://elitevacances.com/"
              target="_blank"
              rel="noreferrer"
            >
              <LogoSVG className="text-white" width={200} />
            </a>
          </div>
          <div className="col-sm-6 col-md-3 col-lg-3 col-xl-3 mx-auto">
            <p className="text-uppercase fw-bold mb-4">Legales</p>
            <p>
              <a
                href="https://elitevacances.com/sagrilaft"
                className="text-reset"
                target="_blank"
                rel="noopener noreferrer"
              >
                <strong>SAGRILAFT Y PTEE</strong>
              </a>
            </p>
            <p>
              <a
                href="https://assets.elitevacances.com/TRATAMIENTO_DATOS_PERSONALES.pdf"
                target="_blank"
                className="text-reset"
                rel="noopener noreferrer"
              >
                Política de tratamiento de datos personales
              </a>
            </p>
            <p>
              <a
                href="https://assets.elitevacances.com/AVISO_PRIVACIDAD.pdf"
                target="_blank"
                className="text-reset"
                rel="noopener noreferrer"
              >
                Aviso de privacidad
              </a>
            </p>
          </div>
          <div className="col-md-3 col-lg-3 col-xl-3 mx-auto">
            <p className="text-uppercase fw-bold mb-4"></p>
            <p>
              <a
                href="https://elitevacances.com/politica-de-ley-de-retracto/"
                className="text-reset"
                target="_blank"
                rel="noopener noreferrer"
              >
                Política ley de retracto
              </a>
            </p>
            <p>
              <a
                href="https://elitevacances.com/politica-de-proteccion-de-menores"
                className="text-reset"
                target="_blank"
                rel="noopener noreferrer"
              >
                Política de protección a menores
              </a>
            </p>
          </div>
          <div className="col-md-3 col-lg-3 col-xl-3 mx-auto mb-md-0">
            <p className="text-uppercase fw-bold mb-4">Contacto</p>
            <p>Bogotá, Colombia</p>
            <p>
              <a
                className="text-white"
                href="mailto:sac@elitevacances.com"
                rel="noopener noreferrer"
              >
                sac@elitevacances.com
              </a>
            </p>
            <p>
              <a
                className="text-white"
                href="tel:+576017945996"
                rel="noopener noreferrer"
              >
                (601)7945996
              </a>
            </p>
          </div>
        </div>
        <div className="text-center p-4">
          <span>
            RNT No 280829. Elite Vacances SAS advierte al usuario que en
            desarrollo de lo dispuesto en la Ley 679/01 y 1336/09 la explotación
            y el abuso sexual de niños, niñas y adolescentes en el país son
            sancionadas penal y administrativamente, conforme a las leyes
            vigentes. Oficina Principal Bogotá, Calle 93B # 19-57 oficina 302.
          </span>
          <p>
            <a
              className="text-reset fw-bold"
              href="https://elitevacances.com/"
              rel="noopener noreferrer"
            >
              © {year} | Todos los derechos reservados. Elite Vacances
            </a>
          </p>
        </div>
        <div className="lines">
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
